import React from 'react';

import { createBrowserRouter } from 'react-router-dom';

import DataGrid from '../components/dataGrid/DataGrid';
import UserAuthChecker from '../HOC/auth';
import ContractComponent from '../Pages/Contracts/ContractComponent';
import Drafts from '../Pages/Drafts';
import ViewDraft from '../Pages/Drafts/ViewDraft';
import Root from '../Root';

export const privateRouter = createBrowserRouter([
  {
    path: '*',
    Component: UserAuthChecker(Root),
    children: [
      {
        path: 'dictionary',
        element: <ContractComponent />,
      },
      { path: 'dictionary/:id', element: <DataGrid /> },
      { path: 'drafts', element: <Drafts /> },
      { path: 'draft/:id', element: <ViewDraft /> },
    ],
  },
]);
